import type { MediaRef, SiteSettings } from '../types'

/** Upload URL, or undefined when nothing is set in the CMS. */
export const mediaUrl = (m?: MediaRef | null): string | undefined => m?.url ?? undefined

/** Alt text: the field on the block wins, else the alt stored on the upload. */
export const mediaAlt = (m?: MediaRef | null, override?: string | null): string =>
  override ?? m?.alt ?? ''

const coords = (s: SiteSettings) => {
  const lat = s.maps?.lat
  const lng = s.maps?.lng
  return typeof lat === 'number' && typeof lng === 'number' ? `${lat},${lng}` : null
}

/** Google Maps links are derived from the pin, so editors only manage lat/lng. */
export function mapsLinks(settings: SiteSettings) {
  const q = coords(settings)
  if (!q) return { embed: undefined, view: undefined, directions: undefined }
  return {
    embed: `https://maps.google.com/maps?q=${q}&z=16&hl=es&output=embed`,
    view: `https://www.google.com/maps/search/?api=1&query=${q}`,
    directions: `https://www.google.com/maps/dir/?api=1&destination=${q}`,
  }
}

export const telHref = (phone?: string | null) => (phone ? `tel:${phone}` : undefined)
export const mailHref = (email?: string | null) => (email ? `mailto:${email}` : undefined)
